var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodeIcon = function SvgCodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.304 7.784-5.296-4.708a.297.297 0 1 0-.398.442l5.054 4.487-5.054 4.487a.3.3 0 0 0-.022.42c.059.059.138.093.221.095a.3.3 0 0 0 .199-.074l5.296-4.708a.3.3 0 0 0 0-.441M1.136 8.005l5.053-4.487a.297.297 0 0 0-.397-.442L.496 7.784a.3.3 0 0 0 0 .441l5.296 4.708a.3.3 0 0 0 .42-.022.3.3 0 0 0-.023-.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.6,
    d: "m15.304 7.784-5.296-4.708a.297.297 0 1 0-.398.442l5.054 4.487-5.054 4.487a.3.3 0 0 0-.022.42c.059.059.138.093.221.095a.3.3 0 0 0 .199-.074l5.296-4.708a.3.3 0 0 0 0-.441ZM1.136 8.005l5.053-4.487a.297.297 0 0 0-.397-.442L.496 7.784a.3.3 0 0 0 0 .441l5.296 4.708a.3.3 0 0 0 .42-.022.3.3 0 0 0-.023-.42z"
  })));
};
export default SvgCodeIcon;